export var STATUS_NOT_FOUND = 404;
export var STATUS_INTERNAL_SERVER_ERROR = 500;
export var STATUS_CONFLICT = 409;
export var ERROR_PAGES = [STATUS_NOT_FOUND, STATUS_INTERNAL_SERVER_ERROR];
export var isErrorPage = function (pathname) { return ERROR_PAGES.includes(Number(pathname)); };
